/* eslint-disable @typescript-eslint/await-thenable */
import * as React from 'react';
import { FlatViewOrderSinglePageDesktop, ICallbackParams } from '@cian/newbuilding-flat-view-order-component';
import { Button } from '@cian/ui-kit';
import { useSelector, useDispatch } from 'react-redux';
import { addFlatTourBooking } from '../../../browser/services/flatTourBooking';
import { getFlatTourBookingSchedule, getIsFlatTourBookingAvailable } from '../../selectors/flatTourBooking';
import { getDisplayName, getIsFlatViewOrderEnabled, getNewbuildingId } from '../../selectors/newbuilding';
import { trackFlatViewOrderPopupOpen, trackFlatViewOrderSuccess } from './tracking';

export function FlatViewOrderPopupContainer() {
  const [isPopupOpened, setPopupVisibility] = React.useState(false);
  const dispatch = useDispatch();
  const isFlatTourBookingAvailable = useSelector(getIsFlatTourBookingAvailable);
  const isEnabled = useSelector(getIsFlatViewOrderEnabled);
  const newbuildingName = useSelector(getDisplayName);
  const newbuildingId = useSelector(getNewbuildingId);
  const schedule = useSelector(getFlatTourBookingSchedule);

  const onButtonClick = React.useCallback(() => {
    trackFlatViewOrderPopupOpen('personal_tour_blockJK');

    setPopupVisibility(true);
  }, [setPopupVisibility]);

  const onSuccess = React.useCallback((params: ICallbackParams) => {
    trackFlatViewOrderSuccess(params);
  }, []);

  const onSubmit = React.useCallback(
    async (params: ICallbackParams) => {
      try {
        const parameters = {
          phone: params.phone,
          tourTime: `${params.date} ${params.time}`,
          fullName: params.name,
          newbuildingId,
        };

        await dispatch(addFlatTourBooking(parameters));

        return true;
      } catch {
        return false;
      }
    },
    [dispatch],
  );

  const onPopupClose = React.useCallback(() => {
    setPopupVisibility(false);
  }, []);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Button theme="fill_white_primary" size="M" onClick={onButtonClick} disabled={!isFlatTourBookingAvailable}>
        Записаться на просмотр
      </Button>
      {schedule && (
        <FlatViewOrderSinglePageDesktop
          isOpen={isPopupOpened}
          onClose={onPopupClose}
          onSuccess={onSuccess}
          onSubmit={onSubmit}
          disabledDays={schedule.disabledDays}
          availableDates={schedule.availableDates}
          newbuildingName={newbuildingName}
          minDate={schedule.minDate}
          maxDate={schedule.maxDate}
          nextDate={schedule.nextDate}
          nextNextDate={schedule.nextNextDate}
        />
      )}
    </>
  );
}
